var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.03324 21.9996C1.29268 21.9918 1.53846 21.8825 1.71988 21.6972L11.7074 11.7086C12.0975 11.3185 12.0975 10.6864 11.7074 10.2962L1.71988 0.307613C1.47019 0.0461941 1.09761 -0.0591545 0.746486 0.0325375C0.397312 0.124229 0.124216 0.397354 0.0325336 0.746565C-0.0591488 1.09772 0.0461893 1.47035 0.307581 1.72006L9.58895 11.0024L0.307581 20.2848C0.0130272 20.5715 -0.076705 21.0105 0.083252 21.3909C0.245158 21.7694 0.621642 22.0113 1.03324 21.9996Z","fill":"#EBA920"}));
}

ArrowRight.defaultProps = {"width":"12","height":"22","viewBox":"0 0 12 22","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
